import takeRequest from '~/store/takeRequest';
import { getUsers, getRolesByUser } from '~/store/permLevels/actions';

export function* permLevelsSaga() {
  yield takeRequest(getUsers);
  yield takeRequest(getRolesByUser);
}
